<template>

    <form v-on:submit.prevent="inference()" class="modal-card" style="min-width: 10em;">
        
        <section class="modal-card-body" style="height: auto">
            <h2 class="title is-4 has-text-centered">
                <small>
                    <p class="subtitle is-7 is-uppercase">Explore model hub</p>
                </small>
                {{  model.name }}
                <br>
            

                <b-tag size="is-small" type="is-primary"><i class="fa fa-brain"></i>&nbsp;{{ model.type }}</b-tag>&nbsp;
                <b-tag size="is-small" type="is-primary"><i class="fa fa-language"></i>&nbsp;multilingual</b-tag>&nbsp;
                <b-tag v-if="!currentUser" size="is-small" type="is-dark"><i class="fa fa-lock"></i>&nbsp;account required</b-tag>
            </h2>
            <p class="subtitle is-5 has-text-centered">
                    {{  model.description }}
                </p>
            <b-tabs  size="is-medium" type="is-boxed" >
            <b-tab-item label="Playground">
                
                <!-- <p>
                    
                    <b-button role="a" href="https://metatext.ai/documentation" target="_blank" class="is-pulled-right" size="is-small">
                        <i class="fa fa-link"></i>&nbsp;View code
                    </b-button>
                </p> -->
                &nbsp;
                <b-input maxlength="500" 
                    rows="3"
                    required
                    type="textarea" v-model="text" 
                    placeholder="Type your text here">
                </b-input>
                <b-button
                tag="button"
                native-type="submit"
                label="Inference"
                type="is-primary"
                :disabled="disableButton"
                expanded />
                <br>
                <b-notification ref="result" v-if="model.type == 'extraction'" style="overflow-wrap: break-word; color: #f1f1f1; background: #222;" :closable="false">
                    <span :key="r" v-for="r in highlight(result['prediction'])">
                        <span v-html="r"></span>
                    </span>
                </b-notification>
                <b-notification v-else ref="result" style="overflow-wrap: break-word; color: #f1f1f1; background: #222;" :closable="false">
                &nbsp;{{ "prediction" in result ? result["prediction"] : result | pretty }}
                </b-notification>
                <small v-if="model.labels">
                    <p class="subtitle is-7">
                
                    <b class="">Possible labels</b>:
                    
                    <span :key="label" v-for="label in model.labels">
                        {{  label }}
                    </span>
                    </p>
                </small>

                <br>
                <b-notification :closable="false">
                     Looking for a perfect fit or something specific? <br>
                    <router-link
                        :to="`/dashboard/start/${model.type}`"
                        size="is-small" type="dark" expanded>
                        🚀  Level up this AI: <b>Train with your data</b>
                    </router-link>
                </b-notification>
            </b-tab-item>
            <b-tab-item label="View API code">
                <b-button expanded tag="router-link" type="is-primary" :to="'/account/settings'">
                    <i class="fa fa-link"></i> Get Your API Key
                </b-button>
                <br>
                
                cURL request:
                <b-notification style="background: #222;" :closable="false">
                <code style="color: #f1f1f1; background: #222;">$ curl --request POST \<br>
--url https://api.metatext.ai/v1/hub/inference/{{ model.id }} \<br>
--header 'content-type: application/json' \<br>
--header 'x-api-key: YOUR_API_KEY' \<br>
--data '{"text": "{{ text }}"}'</code>
                </b-notification>
                
                JSON response:
                <b-notification style="overflow-wrap: break-word; color: #f1f1f1; background: #222;" :closable="false">
                &nbsp;{{ result | pretty }}
                </b-notification>
                <b-button
                v-if="!currentUser"
                role="a"
                href="https://metatext.ai/signup"
                tag="button"
                type="is-primary"
                expanded>
                Create an account to <b>get your API Key</b>
                </b-button>
            </b-tab-item>
            </b-tabs>
        </section>
        <!-- <footer class="modal-card-foot">
            <b-button
                label="Close"
                @click="$emit('close')" />
            <b-button
                tag="button"
                native-type="submit"
                label="Create"
                type="is-primary"
                expanded />
        </footer> -->
    </form>
    </template>
    <script>
    
    
    export default {
       props: ["model", "currentUser"],
      data() {
        return {
          text: this.model.examples[0].input,
          result: {'prediction': this.model.examples[0].output},
          radio: 'binary',
          dataset: null,
          modelName: '',
          modelType: 'binary',
          trainingModels: 2,
          isFinished: false,
          disableButton: false
        };
      },
      created() {
        document.title = this.model.name + " - Model Hub - Metatext"
      },
      filters: {
            pretty: function(value) {
                
                return JSON.stringify(value, null, 2);
            }
        },
      computed: {
      },
      methods: {
        highlight(result) {
            if(!Array.isArray(result) && this.model.type != 'extraction') {
                return result;
            }
            let highlight = []
            let highlight_text = this.text
            result.forEach(async (r) => {
                highlight_text = highlight_text.replace(new RegExp(r.text, "gi"), match => {
                    return `<span style="margin-bottom: 5px" data-entity="${r.label.toLowerCase()}">${match} <span class='entities-type'><b>${r.label}</b></span></span>`;
                });
                
                highlight.push(highlight_text)
            });
            
            return highlight.slice(-1)
        },
        inference(){
            
            if (!this.currentUser){
                
                this.$buefy.dialog.alert({
                    message: '<h1><i class="fa fa-lock"></i> Account required.</h1>',
                    confirmText: 'Sign Up for Free',
                    onConfirm: () => {
                        setTimeout(() => {
                            this.$router.push(`/login`)
                        },  1)
                    }
                })
                
            } else {
                let isFullPage = false
                this.disableButton = true
                const loadingComponent = this.$buefy.loading.open({
                    container: isFullPage ? null : this.$refs.result.$el
                })
                this.$store.dispatch(
                    "getPreBuildModelInference",
                    {text: this.text, labels: false, modelId: this.model.id}
                ).then( (res) => {
                    this.disableButton = false
                    this.result = {prediction: res}
                    loadingComponent.close()
                    
                })
                
            }
            
        }
      },
        
    }
    </script>